/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ProfessionalInterestSurveySubmission,
} from './platformapi.schemas';

import submitProfessionalInterestSurveyMutator from '../custom-axios-instance';

/**
 * Records an anonymous "professional pause" interest survey submission. This is intentionally
unauthenticated - no account is created as part of this flow.
 * @summary Submit Professional Interest Survey
 */
export const submitProfessionalInterestSurvey = (
  professionalInterestSurveySubmission: ProfessionalInterestSurveySubmission,
  signal?: AbortSignal,
) => {
  return submitProfessionalInterestSurveyMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/professional-interest-survey/submit`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: professionalInterestSurveySubmission,
    signal,
  });
};

export const getSubmitProfessionalInterestSurveyMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitProfessionalInterestSurvey>>,
    TError,
    { data: ProfessionalInterestSurveySubmission },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitProfessionalInterestSurvey>>,
  TError,
  { data: ProfessionalInterestSurveySubmission },
  TContext
> => {
  const mutationKey = ['submitProfessionalInterestSurvey'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitProfessionalInterestSurvey>>,
    { data: ProfessionalInterestSurveySubmission }
  > = (props) => {
    const { data } = props ?? {};

    return submitProfessionalInterestSurvey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitProfessionalInterestSurveyMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitProfessionalInterestSurvey>>
>;
export type SubmitProfessionalInterestSurveyMutationBody = ProfessionalInterestSurveySubmission;
export type SubmitProfessionalInterestSurveyMutationError = void | HTTPValidationError;

/**
 * @summary Submit Professional Interest Survey
 */
export const useSubmitProfessionalInterestSurvey = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitProfessionalInterestSurvey>>,
      TError,
      { data: ProfessionalInterestSurveySubmission },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitProfessionalInterestSurvey>>,
  TError,
  { data: ProfessionalInterestSurveySubmission },
  TContext
> => {
  const mutationOptions = getSubmitProfessionalInterestSurveyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
